import { AppBase, AppOptions, createGraphicsDevice, registerScript, DEVICETYPE_WEBGL2, FILLMODE_FILL_WINDOW, RESOLUTION_AUTO } from 'playcanvas';
import { AnimComponentSystem, RenderComponentSystem, CameraComponentSystem, LightComponentSystem, ScriptComponentSystem } from 'playcanvas';
import { ContainerHandler, TextureHandler } from 'playcanvas';

import { useEffect, useRef } from 'react';

import Camera from '../scripts/camera.js';
import Input from '../scripts/input.js';

import { initialize as appInitialize } from '../scripts/application.js';



export default function Renderer({ onInitialize }) {
    const canvasRef = useRef(null);

    useEffect(() => {
        initialize();
    }, []);

    async function initialize() {
        const device = await createGraphicsDevice(canvasRef.current, {
            deviceTypes: [ DEVICETYPE_WEBGL2 ],
            antialias: false,
            xrCompatible: false,
            preserveDrawingBuffer: true,
            alpha: true
        });
        device.maxPixelRatio = Math.min(window.devicePixelRatio, 2);

        // options
        const options = new AppOptions();
        options.graphicsDevice = device;
        options.componentSystems = [
            AnimComponentSystem,
            RenderComponentSystem,
            CameraComponentSystem,
            LightComponentSystem,
            ScriptComponentSystem
        ];
        options.resourceHandlers = [
            ContainerHandler,
            TextureHandler
        ];

        // app
        const app = window.app = new AppBase(canvasRef.current);
        app.init(options);
        app.scene.clusteredLightingEnabled = false;

        // resizing
        app.setCanvasFillMode(FILLMODE_FILL_WINDOW);
        app.setCanvasResolution(RESOLUTION_AUTO);
        window.addEventListener('resize', () => app.resizeCanvas());
        
        // scripts
        registerScript(Camera.class, Camera.name, app);
        registerScript(Input.class, Input.name, app);

        // initialize application
        await appInitialize(app);

        // start
        app.start();

        onInitialize(app);
    }

    return (
        <canvas id='canvas' ref={canvasRef}></canvas>
    );
}
